import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBellNotifications = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C12.4142 2 12.75 2.33579 12.75 2.75V3.28832C16.4017 3.66362 19.25 6.74918 19.25 10.5V13.5365L19.6397 13.7313C20.6266 14.2248 21.25 15.2335 21.25 16.3369C21.25 17.9458 19.9458 19.25 18.3369 19.25H15.6755C15.3287 20.9681 13.813 22.25 12 22.25C10.1868 22.25 8.67285 20.961 8.32511 19.25H5.66312C4.04577 19.25 2.75 17.9183 2.75 16.3179C2.75 15.2071 3.38016 14.2214 4.36033 13.7313L4.75 13.5365V10.5C4.75 6.74918 7.59833 3.66362 11.25 3.28832V2.75C11.25 2.33579 11.5858 2 12 2ZM18.3369 17.75C19.1173 17.75 19.75 17.1173 19.75 16.3369C19.75 15.8016 19.4476 15.3123 18.9688 15.0729L18.1646 14.6708C17.9105 14.5438 17.75 14.2841 17.75 14V10.5C17.75 7.32436 15.1756 4.75 12 4.75C8.82436 4.75 6.25 7.32436 6.25 10.5V14C6.25 14.2841 6.0895 14.5438 5.83541 14.6708L5.03115 15.0729C4.54567 15.3157 4.25 15.7901 4.25 16.3179C4.25 17.1069 4.89115 17.75 5.66312 17.75H18.3369ZM9.87828 19.25C10.1875 20.1235 11.0213 20.75 12 20.75C12.9812 20.75 13.8151 20.127 14.123 19.25H9.87828Z",
		fill: "currentColor"
	})
});
export { SvgIconBellNotifications as ReactComponent };
